export default __webpack_public_path__ + "static/media/salad@3x.8500b90a.jpg";